import { TDrmInfo } from '../types'

const safari: TDrmInfo = {
  type: 'fairplay',
  format: 'HLS',
}

const tizen: TDrmInfo = {
  type: 'widevine',
  format: 'DASH',
}

const xbox: TDrmInfo = {
  type: 'playready',
  format: 'DASH',
}

// Note: no idea what we want for these; just a placeholder
const comcast: TDrmInfo = {
  type: 'widevine',
  format: 'DASH',
}

const browser: TDrmInfo = {
  type: 'widevine',
  format: 'DASH',
}

export const drmByPlatform = {
  browser,
  safari,
  tizen,
  xbox,
  comcast,
}
